import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'

export default {
  name: 'registerComplete',
  components: {
    SharedHeader,
    SharedFooter
  },
  computed: {
    user () {
      return this.$store.getters.user
    }
  },
  created () {
    // let script = document.createElement('script')
    // script.setAttribute('src', `https://r.moshimo.com/af/r/result.js?p_id=2108&pc_id=4356&m_v=${this.user.studentId}`)
    // script.setAttribute('id', 'msmaf')
    // document.head.appendChild(script)
    //
    // let img = document.createElement('img')
    // img.setAttribute('src', `https://r.moshimo.com/af/r/result?p_id=2108&pc_id=4356&m_v=${this.user.studentId}`)
    // img.setAttribute('width', 1)
    // img.setAttribute('height', 1)
    // img.setAttribute('alt', '')
  }
}



// WEBPACK FOOTER //
// ./src/components/register/complete/complete.js